import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ClinicRegistration from "./ClinicRegistration";
import TokenRefresher from "./TokenRefresher";
import SearchPage from "./pages/search-page/SearchPage";
import { ReportsPage } from "./pages/reports-page/ReportsPage";
import Navigation from "./widgets/navigation/Navigation";
import DashboardPage from "./pages/dashboard-page/DashboardPage";
import DatalensPage from "./pages/datalens-page/DatalensPage";
import LoginPage from "./pages/login-page/LoginPage";
import PrivateRoute from "./shared/auth/PrivateRoute";
import TestTranscribePage from "./pages/test-transcribe-page/TestTranscribePage";
import ClinicManagementPage from "./pages/ClinicManagementPage/ClinicManagementPage";
import WorkSchedulePage from "./pages/WorkSchedulePage/WorkSchedulePage";
// Логотип находится в папке public и доступен напрямую

// Основной компонент приложения
const App = () => {
  return (
    <Router>
                  <div className="min-h-screen bg-white text-gray-800">
        <div className="max-w-6xl mx-auto p-6">
          <header className="app-header">
            <div className="logo-container">
              <img src="/1.svg" alt="MedAI ClientAPP Logo" className="h-12" />
            </div>
            <Navigation />
          </header>

          <Routes>
            <Route path="/" element={<SearchPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/refresh-token" element={<TokenRefresher />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/datalens" element={<DatalensPage />} />
            <Route path="/test-transcription" element={<TestTranscribePage />} />
            <Route path="/admin" element={<LoginPage />} />
            <Route element={<PrivateRoute />}>
              <Route path="/admin/register-clinic" element={<ClinicRegistration />} />
              <Route path="/admin/manage-clinic" element={<ClinicManagementPage />} />
              <Route path="/admin/work-schedule" element={<WorkSchedulePage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
